import template from './template.html';
import blockBase from "../../mixins/blockBase";

export default {
    name: 'facts',
    template: template,
    mixins: [
        blockBase,
    ],
    computed: {
        isEven() {
            return this.block.facts.length % 2 == 0;
        }
    }
};